// import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
// import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React, { useContext, useReducer } from 'react';
import { toast } from 'react-toastify';

import postProductType from '../../../../../api/oc_product/productDataManagement/productTypes/post/postProductType';
import Modal from '../../../../../components/Modal';
import VirtualizedAutocomplete from '../../../../../components/VirtualizedAutocomplete';
import { ProductTypeContext } from '../../ProductTypeContext';

const reducer = (state, action) => {
  switch (action.type) {
    case 'ATTRIBUTE':
      return {
        ...state,
        attribute: action.payload,
      };
    default:
      return state;
  }
};
function CreateModal({
  open,
  onClose,
}) {
  const {
    siteCode,
    siteAttributeOptions,
    // handlePopoverClose,
    name,
    setName,
    siteId,
    fetchData,
    setRows,
    setAnchorEl,
    initialState,
    // loading,
  } = useContext(ProductTypeContext);
  const [newDepartmentCode, setNewDepartmentCode] = React.useState('');
  const [selectedAttribute, setSelectedAttribute] = React.useState([]);
  const [newIsDefault, setNewIsDefault] = React.useState(false);
  const [disableBtn, setDisableBtn] = React.useState(true);

  const initialFormState = {
    definitionKey: '',
    name: '',
    eName: '',
    sites: [],
    attributeDataType: null,
    readOnly: false,
    isMandatory: false,
    isHidden: false,
    searchKeywords: false,
  };
  const [loading, setLoading] = React.useState(false);

  const [state, dispatch] = useReducer(reducer, initialFormState);
  const handleClose = () => {
    onClose(false);
    setName('');
    setNewDepartmentCode('');
    setSelectedAttribute([]);
    setNewIsDefault(false);
  };
  const handleNameChange = (value) => {
    if (value === '') {
      setDisableBtn(true);
    } else if (value !== '' && selectedAttribute.length > 0) {
      setDisableBtn(false);
    }
  };
  const handleAttributeChange = (event, values) => {
    setDisableBtn(false);
    const selectedIds = values.map((v) => v.ProductAttributeDefId);
    if (selectedIds.length === 0 || name === '') {
      setDisableBtn(true);
    } else if (name !== '' && selectedAttribute.length > 0) {
      setDisableBtn(false);
    }
    setSelectedAttribute(selectedIds);
    dispatch({ type: 'ATTRIBUTE', payload: selectedIds });
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setName('');
    setNewDepartmentCode('');
    setNewIsDefault(false);
    dispatch({ type: 'ATTRIBUTE', payload: initialState.attribute });
    setSelectedAttribute([]);
  };
  const handleCreateProductType = async () => {
    try {
      setLoading(true);
      const attributeId = state.attribute || 0;
      const productTypeData = await postProductType(
        siteId,
        name,
        newDepartmentCode,
        attributeId,
        newIsDefault,
      );
      const relevantData = productTypeData.data.Data || [];
      const mappedRows = relevantData.map((item, index) => ({
        id: index + 1,
        name: item.ProductTypeName,
        departmentCode: item.DepartmentCode,
        default: item.IsDefault,
        dateCreated: item.Created,
        productTypeId: item.ProductTypeId,
      }));
      setRows(mappedRows);
      setDisableBtn(true);
      await fetchData();
      handlePopoverClose();
      toast.success('Succesfully Created Product Type');
      onClose(false);
    } catch (error) {
      console.error('Error saving product type', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      buttonLabel="Save"
      onClose={handleClose}
      desktopModalWidth="30%"
      leftPosition="100%"
      containerWidth="xl"
      buttonOnClick={handleCreateProductType}
      buttonLoading={loading}
      disableButton={disableBtn}
    >
      <div className="flex flex-row min-h-[200px]">
        <Grid container spacing={2} marginTop>
          <Grid item xs={12} container justifyContent="space-between" alignItems="center">

            <div className="flex flex-col p-2">
              <Typography variant="h6" className="mb-3">
                Create New Product Type -
                {siteCode}
              </Typography>
              <div className="flex flex-row items-center mb-3">
                <TextField
                  label="Name"
                  variant="outlined"
                  size="small"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    handleNameChange(e.target.value);
                    dispatch({ type: 'NAME', payload: e.target.value });
                  }}
                  className="w-[400px]"
                />
              </div>
              <div className="flex flex-row items-center mb-3">
                <TextField
                  label="Department Code"
                  variant="outlined"
                  size="small"
                  value={newDepartmentCode}
                  onChange={(e) => setNewDepartmentCode(e.target.value)}
                  className="w-[400px]"
                />
              </div>
              <div className="flex flex-row items-center mb-3">
                <VirtualizedAutocomplete
                  multiple
                  key="Attribute"
                  options={siteAttributeOptions || []}
                  textFieldLabel="Attribute"
                  textFieldVariant="outlined"
                  size="small"
                  getOptionLabel={(option) => (option ? option.AttributeName : '')}
                  onChange={handleAttributeChange}
                  optionKey="AttributeName"
                  value={siteAttributeOptions.filter((obj) => selectedAttribute.includes(obj.ProductAttributeDefId)) || []}
                  className="w-[400px]"

                />
              </div>
              <div className="flex flex-row items-center mt-3 mb-3">
                <p className="text-[14px]">Is Default</p>
                <Checkbox
                  onClick={(event) => setNewIsDefault(event.target.checked)}
                  checked={newIsDefault}
                  className="mr-0"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default CreateModal;
